/**
 * @module findDataPointCategory
 */

/**
 * @enum
 * An enum for the types of Data points
 * @property {number} Elemental - For a basic type of data point
 * @property {number} Action - For an action type data point
 * @property {number} ExtendedAction - For an extended action type data point
 * @property {number} Render - For rendering data point
 */

export enum DataPointType {
    Elemental,
    Action,
    HttpAction,
    ExtendedAction,
    Render,
}

/**
 * @constant
 * Category for every type of telemetry events
 */

const DataPointCategory = {
    /**
     * TODO: Move event names to constant file and consume them in respective packages
     */
    [DataPointType.Elemental]: [
        'ActionCardExpanded',
        'ActionCardCollapsed',
        'MessageCardHidden',
        'MessageCardRemoved',
        'MessageCardViewActionClicked',
        'TransactionCardDisabled',
    ],
    [DataPointType.Action]: [
        'ToggleVisibilityActionClick',
        'DisplayAppointmentFormClicked',
        'DisplayMessageFormClicked',
        'MessageCardPinAddinCommandClicked',
        'MessageCardInvokeAddinCommandClicked',
        'TransactionActionEvent',
    ],
    [DataPointType.HttpAction]: [
        'ActionCardHttpPostActionClicked',
        'SingleClickHttpPostActionClicked',
        'AutoInvokeActionClicked',
    ],
    [DataPointType.ExtendedAction]: ['HttpPostActionExecuted'],
    [DataPointType.Render]: ['MessageCardRendered'],
};

const findDataPointCategory = (eventName: string): DataPointType => {
    let category;
    if (DataPointCategory[DataPointType.Render].includes(eventName)) {
        category = DataPointType.Render;
    } else if (DataPointCategory[DataPointType.ExtendedAction].includes(eventName)) {
        category = DataPointType.ExtendedAction;
    } else if (DataPointCategory[DataPointType.HttpAction].includes(eventName)) {
        category = DataPointType.HttpAction;
    } else if (DataPointCategory[DataPointType.Action].includes(eventName)) {
        category = DataPointType.Action;
    } else {
        category = DataPointType.Elemental;
    }
    return category;
};

export default findDataPointCategory;
